var lib_core = require("lib-core");

/**
 * @constructor
 */
var Editor2DStateMachine = function (root, model) {
    var self = this;
    self.root = root;

    this.model = model;

    lib_core.StateMachine.call(this, this.model.state);

    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.EXPAND_CLICK);
        },
        function(cEvent){
            self.root.rec();
            cEvent.element().data.expand(null, self.model.geometryPrecision());
            self.root.stopRec();
        }
    );

    // keep track of last mouse position for cases where it is not available
    // this happens when events come from above editor (tab etc.)
    this.addEventAction(/.*/,
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_DOWN
                    || cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP
                    || cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_WHEEL);
        },
        function(cEvent){
            var eventCoord = cEvent.data('mouseCoord');
            if(eventCoord) {
                var pos = self.model.cameraModel().toRealCoord(cEvent.data('mouseCoord'));
                var displacement = pos.sub(self.model.mousePos());
                self.model.mouseDisplacement(displacement);
                self.model.mousePos(pos);
            }
        }
    );
};

lib_core.inherit(Editor2DStateMachine, lib_core.StateMachine);

module.exports = Editor2DStateMachine;
